/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import thumbnailImg from 'assets/images/tumbnailImg.svg';
import { Button, Input, SimpleSelect } from 'components/atoms';
import { Loader } from 'components/atoms/Loader';
import { Modal } from 'components/molecules/Modal';
import {
  useGetAllVideos,
  useGetVideosBySearch,
  useSendVideoDeletionRequest,
} from 'framework/api/methods';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDebounce from 'utils/debounce';

export interface VideosProps {
  [x: string]: any;
}

export const Videos: FC<VideosProps> = () => {
  const navigate = useNavigate();
  const { userDetails: user }: any = useSelector<any>((state) => state.user);

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [selectedState, setSelectedState] = useState({
    label: 'Approved',
    value: 'approved',
  });

  const [searchText, setSearchText] = useState('');
  const [isOpenDeleteConfirmation, setIsOpenDeleteConfirmation] = useState(false);
  const [videoList, setVideoList] = useState([]);

  const [isTyping, setIsTyping] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState('');
  const { mutate: getAllVideosMutate, isLoading: getAllVideosIsLoading } = useGetAllVideos();
  const { mutate: getAllVideosBySearchMutate, isLoading: getAllVideosBySearchIsLoading } =
    useGetVideosBySearch();
  const { mutate: sendVideoDeletionRequestMutate, isLoading: sendVideoDeletionRequestIsOnLoading } =
    useSendVideoDeletionRequest();

  // function to get all videos
  const getAllVideos = (status: string) => {
    setSearchText('');
    getAllVideosMutate(
      {
        status,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setVideoList(successData.videos || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setVideoList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to delete video
  const sendVideoDeletionRequest = () => {
    sendVideoDeletionRequestMutate(
      {
        video: selectedVideo,
        status: 'deleted',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          getAllVideos(selectedState.value);
          setSelectedVideo('');
          setIsOpenDeleteConfirmation(false);
          notify(successData?.message || 'Send delete request', 'success');
        },
        onError: ({ response: { data: errData }, response }: any) => {
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  // function to get all videos for search
  const getAllVideosBySearch = (status: string) => {
    getAllVideosBySearchMutate(
      {
        status,
        searchKeyword: searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setVideoList(successData.videos || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setVideoList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    if (isTyping && debouncedSearchText.trim() !== '') {
      getAllVideosBySearch(selectedState.value);
    } else {
      getAllVideos(selectedState.value);
    }
  }, [debouncedSearchText]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins > 0 && secs > 0) {
      return `${mins.toString().padStart(2, '0')} min ${secs.toString().padStart(2, '0')} sec`;
    }
    if (mins > 0) {
      return `${mins.toString().padStart(2, '0')} min`;
    }
    return `${secs.toString().padStart(2, '0')} sec`;
  };

  return (
    <div className="flex flex-col w-full h-full py-6 px-8">
      <div className="flex justify-between items-center">
        <div className="w-1/3">
          <div className="w-[180px] bg-[#f7951e24]">
            <SimpleSelect
              isSearchable={false}
              value={selectedState}
              options={[
                {
                  label: 'Approved',
                  value: 'approved',
                },
                {
                  label: 'Pending',
                  value: 'pending',
                },
                {
                  label: 'Rejected',
                  value: 'rejected',
                },
                {
                  label: 'Deleted',
                  value: 'deleted',
                },
              ]}
              onChange={(e: any) => {
                setSelectedState(e);
                setSearchText('');
                setIsTyping(false);
                if (searchText === '') {
                  getAllVideos(e.value);
                }
              }}
            />
          </div>
        </div>

        <div className="md:block hidden w-1/3">
          <Input
            icon="ri-search-line !text-[#F7941E] font-semibold"
            value={searchText}
            placeholder="Search here..."
            onChange={(e) => {
              setSearchText(e.target.value);
              setIsTyping(true);
            }}
          />
        </div>

        <div className="md:flex w-1/3 hidden justify-end">
          <Button
            isRounded
            size="sm"
            onClick={() => {
              if (user?.status !== 'completed') {
                notify('Please complete your profile before uploading videos.', 'error');
              } else {
                navigate('/videos/upload');
              }
            }}
          >
            <i className="ri-add-line pr-1" />
            Upload
          </Button>
        </div>
      </div>

      <div className="h-full overflow-y-auto w-full mt-5">
        {(getAllVideosIsLoading || getAllVideosBySearchIsLoading) && (
          <Loader appearance="black" className="mt-5" />
        )}

        {!(getAllVideosIsLoading || getAllVideosBySearchIsLoading) && videoList?.length === 0 && (
          <div className="mt-5 text-sm text-center w-full text-neutral-500">No videos found.</div>
        )}
        {!(getAllVideosIsLoading || getAllVideosBySearchIsLoading) &&
          videoList?.map((video: any, index) => (
            <div className="p-3 flex bg-white rounded w-full h-fit mt-2" key={index}>
              <div className="flex lg:h-[100px] h-auto gap-2 overflow-x-auto justify-between items-start w-full lg:flex-row flex-col">
                <div className="flex lg:w-1/3 w-full gap-x-2 h-full  lg:justify-start md:justify-between">
                  <img
                    src={video?.cover_image_url}
                    alt="img-video"
                    className="h-[100px] w-[180px] object-cover rounded"
                  />

                  <div className="flex flex-col h-full lg:w-fit w-full justify-between items-start">
                    <div className="text-sm font-medium text-[#63717A] max-w-[400px] h-full max-h-[70px] overflow-y-auto">
                      {video?.title || ''}
                    </div>

                    <div className="flex gap-x-1">
                      <i className="ri-eye-fill text-[#F7941E] text-[20px] leading-6" />
                      <div className="text-[14px] leading-6 text-[#63717A]">
                        {video?.view_count || 0}
                      </div>

                      <i className="ri-time-fill text-[#F7941E] text-[20px] leading-6 ml-4" />
                      <div className="text-[14px] leading-6 text-[#63717A]">
                        {formatTime(video?.total_watch_seconds) || ''}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-[#EFEFEF] flex flex-col p-3 gap-x-2 lg:w-[calc(66%-80px)] h-full rounded-md lg:max-w-[calc(66%-80px)] max-w-full w-full">
                  <div className="flex w-full gap-x-3 flex-wrap gap-y-2">
                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Published</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-[145px] rounded text-[#63717A] !h-[24px]">
                        {video?.created_at
                          ? new Date(video.created_at)
                              .toLocaleString('en-US', {
                                month: 'short',
                                day: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                                timeZone: 'UTC', // Force UTC
                              })
                              .replace(',', '')
                          : ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Category</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.category || ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs">Length</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video.length_seconds ? formatTime(video.length_seconds) : ''}
                      </div>
                    </div>

                    <div className="flex gap-x-2 justify-center items-center">
                      <span className="text-xs min-w-[59px]">Monetize</span>
                      <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                        {video?.monetization_status ? 'On' : 'Off'}
                      </div>
                    </div>
                  </div>
                </div>
                {selectedState.value !== 'deleted' && (
                  <div className="lg:flex flex-col gap-y-2 font-thin hidden">
                    <Button
                      className="!w-[38px] !h-[38px] !font-thin"
                      onClick={() => {
                        setSelectedVideo(video.vid);
                        setIsOpenDeleteConfirmation(true);
                      }}
                    >
                      <i className="ri-delete-bin-5-line !font-thin text-[24px]" />
                    </Button>

                    <Button
                      className="!w-[38px] !h-[38px] !bg-[#B3D335] !font-thin"
                      onClick={() => {
                        navigate(`/videos/${video.vid}`, {
                          state: {
                            title: video?.title ?? '',
                            imageUrl: video?.cover_image_url ?? '',
                          },
                        });
                      }}
                    >
                      <i className="ri-pencil-line !font-thin text-[24px]" />
                    </Button>
                  </div>
                )}
              </div>
            </div>
          ))}
      </div>

      <Modal
        isActive={isOpenDeleteConfirmation}
        isHeaderShow={false}
        footerButtonAlignment="center"
        primaryButtonTitle="No"
        secondaryButtonTitle="Yes"
        primaryButtonProps={{
          className: '!w-[100px] border-2 !ml-2',
        }}
        secondaryButtonProps={{
          className: '!w-[100px]',
          isLoading: sendVideoDeletionRequestIsOnLoading,
        }}
        onClickPrimaryBtn={() => {
          setIsOpenDeleteConfirmation(false);
        }}
        onClickSecondaryBtn={() => {
          sendVideoDeletionRequest();
        }}
      >
        <div className="flex flex-col w-full">
          <div className="w-full flex justify-end items-end px-2 pt-1">
            <i
              className="ri-close-line text-base text-[#F7941E]"
              onClick={() => {
                setIsOpenDeleteConfirmation(false);
              }}
            />
          </div>
          <div className="flex flex-col justify-center items-center">
            <i className="ri-question-line text-[35px] text-[#F7941E]" />
            <div className="pt-1 text-base text-center text-[#737791] pb-3">
              Do you wish to delete? <br />
              Once deleted, it cannot be retrieved.
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Videos;
